// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/FacePunch.css */
.face-punch-container {
  position: relative;
  width: 520px; /* Fixed width */
  height: 360px; /* Fixed height */
  margin: 40px auto; /* Centered with top/bottom margin for breathing room */
  background-color: #f0edec0f; /* Dark background for modern look */
  border-radius: 12px; /* Softer rounded corners */
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3); /* Subtle shadow for depth */
  transition: transform 0.3s ease; /* Smooth hover effect */
  margin-top: 10%;
}

.face-punch-container:hover {
  transform: translateY(-4px); /* Slight lift on hover for interactivity */
}

#videoInput {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures video fills container */
  border-radius: 12px; /* Matches container */
}

.overlay-canvas {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none; /* Prevents canvas from blocking interactions */
}
.status-message {
  position: relative;
  margin: 12px auto 0;
  width: fit-content;
  background-color: rgba(40, 167, 69, 0.9);
  color: #ffffff;
  padding: 8px 16px;
  border-radius: 8px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease-in-out;
  text-align: center;
}

.cooldown-message {
  position: relative;
  margin: 8px auto 16px;
  width: fit-content;
  background-color: rgba(220, 53, 69, 0.9);
  color: #ffffff;
  padding: 8px 16px;
  border-radius: 8px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease-in-out;
  text-align: center;
}

/* Fade-in animation for messages */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* Ensure the scan button (if it exists in future iterations) is styled consistently */
#scanButton {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #28a745; /* Professional blue */
  color: #ffffff;
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

#scanButton:hover {
  background-color: #0056b3; /* Darker blue on hover */
  transform: translateX(-50%) scale(1.05); /* Slight scale for feedback */
}

#scanButton:active {
  transform: translateX(-50%) scale(0.95); /* Pressed effect */
}

.employee-info-message {
  margin-top: 10px;
  font-weight: bold;
  color: #28a745;
  font-size: 18px;
  text-align: center;
}

@media (max-width: 480px) {
  .face-punch-container {
    width: 92%;
    height: auto;
    aspect-ratio: 4 / 3;
    margin-top: 240px;
    border-radius: 14px;
  }

  .status-message,
  .cooldown-message {
    width: 90%;
    font-size: 13px;
    margin-top: 16px;
    padding: 10px 14px;
    border-radius: 10px;
  }

  .employee-info-message {
    font-size: 16px;
    margin-top: 8px;
  }

  #scanButton {
    position: relative;
    margin: 20px auto 0;
    display: block;
    padding: 12px 28px;
    font-size: 15px;
    border-radius: 10px;
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/FacePunch/FacePunch.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,YAAY,EAAE,gBAAgB;EAC9B,aAAa,EAAE,iBAAiB;EAChC,iBAAiB,EAAE,uDAAuD;EAC1E,2BAA2B,EAAE,oCAAoC;EACjE,mBAAmB,EAAE,2BAA2B;EAChD,gBAAgB;EAChB,yCAAyC,EAAE,4BAA4B;EACvE,+BAA+B,EAAE,wBAAwB;EACzD,eAAe;AACjB;;AAEA;EACE,2BAA2B,EAAE,2CAA2C;AAC1E;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,kCAAkC;EACrD,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,oBAAoB,EAAE,+CAA+C;AACvE;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,sFAAsF;AACtF;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,yBAAyB,EAAE,sBAAsB;EACjD,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB,EAAE,yBAAyB;EACpD,uCAAuC,EAAE,8BAA8B;AACzE;;AAEA;EACE,uCAAuC,EAAE,mBAAmB;AAC9D;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,eAAe;EACjB;AACF","sourcesContent":["/* src/components/FacePunch.css */\n.face-punch-container {\n  position: relative;\n  width: 520px; /* Fixed width */\n  height: 360px; /* Fixed height */\n  margin: 40px auto; /* Centered with top/bottom margin for breathing room */\n  background-color: #f0edec0f; /* Dark background for modern look */\n  border-radius: 12px; /* Softer rounded corners */\n  overflow: hidden;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3); /* Subtle shadow for depth */\n  transition: transform 0.3s ease; /* Smooth hover effect */\n  margin-top: 10%;\n}\n\n.face-punch-container:hover {\n  transform: translateY(-4px); /* Slight lift on hover for interactivity */\n}\n\n#videoInput {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover; /* Ensures video fills container */\n  border-radius: 12px; /* Matches container */\n}\n\n.overlay-canvas {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  pointer-events: none; /* Prevents canvas from blocking interactions */\n}\n.status-message {\n  position: relative;\n  margin: 12px auto 0;\n  width: fit-content;\n  background-color: rgba(40, 167, 69, 0.9);\n  color: #ffffff;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  animation: fadeIn 0.3s ease-in-out;\n  text-align: center;\n}\n\n.cooldown-message {\n  position: relative;\n  margin: 8px auto 16px;\n  width: fit-content;\n  background-color: rgba(220, 53, 69, 0.9);\n  color: #ffffff;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  animation: fadeIn 0.3s ease-in-out;\n  text-align: center;\n}\n\n/* Fade-in animation for messages */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n/* Ensure the scan button (if it exists in future iterations) is styled consistently */\n#scanButton {\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #28a745; /* Professional blue */\n  color: #ffffff;\n  padding: 10px 24px;\n  border: none;\n  border-radius: 8px;\n  font-family: 'Inter', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n#scanButton:hover {\n  background-color: #0056b3; /* Darker blue on hover */\n  transform: translateX(-50%) scale(1.05); /* Slight scale for feedback */\n}\n\n#scanButton:active {\n  transform: translateX(-50%) scale(0.95); /* Pressed effect */\n}\n\n.employee-info-message {\n  margin-top: 10px;\n  font-weight: bold;\n  color: #28a745;\n  font-size: 18px;\n  text-align: center;\n}\n\n@media (max-width: 480px) {\n  .face-punch-container {\n    width: 92%;\n    height: auto;\n    aspect-ratio: 4 / 3;\n    margin-top: 240px;\n    border-radius: 14px;\n  }\n\n  .status-message,\n  .cooldown-message {\n    width: 90%;\n    font-size: 13px;\n    margin-top: 16px;\n    padding: 10px 14px;\n    border-radius: 10px;\n  }\n\n  .employee-info-message {\n    font-size: 16px;\n    margin-top: 8px;\n  }\n\n  #scanButton {\n    position: relative;\n    margin: 20px auto 0;\n    display: block;\n    padding: 12px 28px;\n    font-size: 15px;\n    border-radius: 10px;\n    transform: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
